module.exports = __webpack_public_path__ + "static/banner-7184d868f43cfaf1cdb8221c2248deb8.jpg";